import React from "react";

const Footer = () => {
  return (
    <footer className="bg-body-tertiary text-center text-lg-start">
      <style>
        {`
          .solivar-link {
            color: inherit; /* Inherit default text color */
            text-decoration: none; /* No underline */
          }

          .solivar-link:hover {
            color: blue; /* Change to blue on hover */
          }

          .footer-text {
            margin: 0 5px; /* Ensure consistent spacing */
          }
        `}
      </style>
      <div
        className="text-center p-3"
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.05)",
          minHeight: "8vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <span>© Copyright</span>
        <a
          className="solivar-link footer-text"
          href="https://solivar.in/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Solivar India
        </a>
        <span>2024. All Rights Reserved.</span>
      </div>
    </footer>
  );
};

export default Footer;
